import { render, staticRenderFns } from "./OrdersTableOrderAsset.vue?vue&type=template&id=1da134c6&scoped=true&"
import script from "./OrdersTableOrderAsset.vue?vue&type=script&lang=js&"
export * from "./OrdersTableOrderAsset.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableOrderAsset.vue?vue&type=style&index=0&id=1da134c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da134c6",
  null
  
)

export default component.exports